import React from 'react';
import { Button } from '@mui/material';

/**
 * 뒤로가기 버튼
 * @param {function} onClick - onClick button event
 * @param {string} text - text
 * @returns
 */
function BackButton({ onClick, text }) {
  return (
    <Button
      type="submit"
      fullWidth
      variant="contained"
      sx={{ mt: 3, mb: 2 }}
      size="large"
      // style={{ boxShadow: 'none', backgroundColor: '#1a9ef8' }}
      onClick={onClick}
    >
      {text}
    </Button>
  );
}

export default BackButton;
